import SlhNavigationOrganizationAvatar from "./src/organization-avatar";

export { SlhNavigationOrganizationAvatar };
